export default "__VITE_ASSET__DzDtnjSt__"